import styled from 'styled-components';

export default styled.div`
	padding: var(--px-3) var(--px-25);
	display: flex;
	flex-wrap: wrap;
	flex-direction: row;
	background-color: var(--neutrals-00white);
	gap: var(--px-50);

	.visual-indicator {
		display: flex;
		align-items: center;
		gap: var(--px-10);
		span {
			display: flex;
		}
		.circle {
			width: var(--px-10);
			height: var(--px-10);
			border-radius: 50%;
			background-color: var(--neutrals-900);
		}
		.check {
			color: var(--teal-500);
		}
	}
`;
